<template>
  <div id="app">
    <div v-if="onLine">
      <v-tour
        v-for="tour in tours"
        :key="tour.id"
        :name="tour.name"
        :steps="tour.data"
        :callbacks="vueToursCallbacks(tour.id)"
      ></v-tour>
      <router-view />
    </div>
    <div v-else>
      <connectionLost />
    </div>
    <b-modal
      id="connectionOffline"
      ref="connectionOffline"
      title="Connection Error"
      centered
      size="md"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      @hide="onHide"
      no-stacking
      hide-header
    >
        <div class="container">
      <div class="row">
        <div class="col-12 col-md-12 align-self-center">
          <div class="text-center">
            <div class="text-center">
              <img
                src="@/assets/img/icons/connection-lost.svg"
                height="85"
                width="85"
                alt="Connection Lost"
              />
              <h4>Connectivity Issue!</h4>
            </div>
            <p>
              We’re having trouble connecting to the server. This might be due
              to a network issue or the server being temporarily unavailable.
            </p>
            <p>
              Please check your internet connection or try again in a few
              moments.
            </p>
            <!-- <div class="text-center">
              <router-link to="/" class="btn-black-lg px-5"
                >Back To Home</router-link
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>

      <template #modal-footer="{ ok }">
        <div class="btn-black-lg px-5" @click="ok()">OK</div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Loader from "@/components/Partials/loader.vue";
import connectionLost from "@/components/Partials/connection-lost.vue";
import Modal from "@/components/Partials/globalModal.vue";
import Tooltip from "@/components/UIElements/Tooltip.vue";
import SetupService from "@/services/SetupService.js";
import MasterService from "@/services/MasterService";
import { getTours, setTourComplete } from "@/helper/tours.js";
import { mapActions, mapGetters } from "vuex";
import { BASEURL } from "@/config/index";
import { backendSocket, EventBus } from "@/main.js";
export default {
  name: "App",
  components: {
    Loader,
    Modal,
    connectionLost,
    Tooltip,
  },
  data() {
    return {
      onLine: navigator.onLine,
      isTimReady: false,
      tours: [],
      vueToursCallbacks: (id) => ({
        onFinish: () => this.handleWalkThroughFinished(id),
        onSkip: () => this.handleWalkThroughFinished(id),
      }),
    };
  },
  head: {
    title() {
      return `Testing`;
    },
    meta: [
      {
        name: "description",
        content() {
          return `Here is the description`;
        },
      },
    ],
  },
  beforeRouteEnter(to, from, next) {
    // return store.fetchSpecial(to.params.slug).then(next)
    next();
  },
  beforeMount() {
    localStorage.removeItem("isTeamReady");
    this.getSetupStatus();
    this.$store.dispatch("fetchGlobalOptions");
    this.$store.dispatch("fetchHealthMeta");
    this.$store.dispatch("fetchOrgDetails");
    if (this.$cookie.get("BRHSID")) {
      try {
        this._GetGlobalOptions();
      } catch (error) {
        this.$toasted.show("Error while fetching global options " + error);
      }
      if (this.secureStore.get("USINFO")) {
        let cinema_id = this.secureStore.get("USINFO").cinema_id;
        let user_id = this.secureStore.get("USINFO").user_id;
        let urlPath = window.location.hash;
        if (
          !urlPath.includes("/pos-booking") &&
          !urlPath.includes("/box-office-fnb") &&
          !urlPath.includes("/pos-fnb") &&
          !urlPath.includes("/pos-lock-screen") &&
          !urlPath.includes("/pos-login") &&
          !urlPath.includes("/pos-fnb-login") &&
          !urlPath.includes("/kitchen-pickup") &&
          !urlPath.includes("/kitchen-sales")
        ) {
          this.$store.dispatch("fetchUserHotPickModules");
          this.$store.dispatch("setDropdownCinema"); // PRESET DROPWDOWN CINEMA IN REPORT IF ONLY ONE CINEMA
        } else {
          //FETCH WHEN ON POS
          this.$store.dispatch("fetchAllCinemasList");
          let DeviceUniqueCode = window.localStorage.getItem(
            "deiviceUniqueCode"
          )
            ? window.localStorage.getItem("deiviceUniqueCode")
            : "";
          if (DeviceUniqueCode) {
            this.$store.dispatch("fetchPosHardwareSettings", DeviceUniqueCode);
          } else {
            console.log("HARDWARE ID NOT FOUND");
          }
        }
        let guest_id = window.localStorage.getItem("guest_user_id");
        if (!guest_id || isNaN(parseInt(guest_id))) {
          guest_id = Math.floor(100000000 + Math.random() * 900000000);
          window.localStorage.setItem("guest_user_id", guest_id);
        }
        this.$store.dispatch("onSetLog", {
          cinema_id: cinema_id,
          user_id: user_id,
        });
      }
    }
    this.tours = getTours(true);
    this.checkToken();
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    if (window.innerWidth < 768) {
      this.setIsMobile(true);
    } else {
      this.setIsMobile(false);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 768) {
        this.setIsMobile(true);
      } else {
        this.setIsMobile(false);
      }
    });
    setTimeout(() => {
      let recaptchaScript1 = document.createElement("script");
      recaptchaScript1.setAttribute("src", `${BASEURL}/Tim/timapi.js`);
      document.head.appendChild(recaptchaScript1);
    }, 100);

    backendSocket.on("LOGOUT_USER_FROM_ALL_MACHINE", (data) => {
      try {
        let logged_user_id = null;
        const JWTTOKEN = window.localStorage.getItem("JWT_TOKEN");
        if (
          this.secureStore.get("USINFO") &&
          this.secureStore.get("USINFO").hasOwnProperty("user_id")
        ) {
          logged_user_id = this.secureStore.get("USINFO").user_id;
        }
        const { token, user_id } = data;
        if (
          logged_user_id &&
          logged_user_id != 1 &&
          logged_user_id == user_id &&
          JWTTOKEN !== token
        ) {
          this.onLogout();
        }
      } catch (err) {
        console.log("Error:", err);
        this.onLogout();
      }
    });

    EventBus.$on("ON_TIM_LOG", (data) => {
      this.generateLogFile(data);
    });

    EventBus.$on("ON_GENERATE_MERCHANT_RECEIPT", (data) => {
      this.generateTimMerchantReceipts(data);
    });

    EventBus.$on("ON_GENERATE_CARDHOLDER_RECEIPT", (data) => {
      this.generateTimCardHolderReceipt(data);
    });

    window.addEventListener("onTimReady", (event) => {
      console.log("window event listener onTimReady", event);
      this.isTimReady = event.storage;
      let recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute("src", `${BASEURL}/Tim/app7.js`);
      document.head.appendChild(recaptchaScript);

      let configObj = {
        pos_id: "",
        ecr_user_id: null,
        ecr_ip_address: "",
        ecr_port: "",
      };

      if (localStorage.getItem("ECR_INFO")) {
        let ECR_INFO = JSON.parse(localStorage.getItem("ECR_INFO"));
        Object.keys(ECR_INFO).map((x) => {
          configObj[x] = ECR_INFO[x];
        });

        if (configObj.ecr_ip_address && configObj.ecr_port) {
          setTimeout((z) => {
            let obj = {
              EventBus: EventBus,
              IPADDRESS: configObj.ecr_ip_address,
              PORT: configObj.ecr_port,
              USERID: configObj.ecr_user_id,
              POSID: configObj.pos_id,
              INTEGRATIONID: "367fcd48-f574-4119-960c-d1ebb00f9a97",
            };
            if (typeof initTimApi == "function") {
              initTimApi(obj);
              localStorage.setItem("ECR_INIT_STATUS", true);
            }
          }, 1000);
        } else {
          localStorage.setItem("ECR_INIT_STATUS", false);
          console.log("ECR Settings not found");
        }
      } else {
        console.log("ECR Settings not found");
      }
    });

    document.addEventListener("wheel", function (event) {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize");
  },
  methods: {
    checkToken() {
      let JWT = window.localStorage.getItem("JWT_TOKEN");
      if (JWT) {
        this.$store.dispatch("setUserProfile");
      }
    },
    onLogout: async function () {
      try {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          if (backendSocket && backendSocket.connected) {
            backendSocket.emit("on_user_logout", {
              hardware_id: this.DeviceUniqueCode,
            });
          }
        }

        let redirectPath = "pos-login";

        if (this.$cookie.get("BRHSID") && this.$cookie.get("BRLF")) {
          if (this.$cookie.get("BRLF") == "admin-login") {
            redirectPath = "/login";
          } else if (this.$cookie.get("BRLF") == "pos-login") {
            redirectPath = "pos-login";
          } else if (this.$cookie.get("BRLF") == "pos-fnb-login") {
            redirectPath = "pos-login";
          } else {
            redirectPath = "/";
          }
        } else {
          redirectPath = "pos-login";
        }

        await this.$store.dispatch("onUserShiftQuit", {});
        await this.$store.dispatch("onResetFnBStoreState");
        await this.$store.dispatch("onResetDateStoreState");
        await this.$store.dispatch("MAKE_DATA_EMPTY");
        var myItem = null;
        if (localStorage.getItem("ECR_INFO")) {
          myItem = localStorage.getItem("ECR_INFO");
        }
        window.localStorage.clear();
        if (myItem) {
          localStorage.setItem("ECR_INFO", myItem);
        }
        this.$cookie.delete("BRHSID");
        this.$router
          .push({
            path: `${redirectPath}`,
          })
          .catch(() => {});
      } catch (err) {
        console.log("Error:", err);
      }
    },
    generateLogFile(data) {
      let payload = {
        data: data,
      };
      if (backendSocket && backendSocket.connected) {
        backendSocket.emit("generate-tim-log", data);
      } else {
        MasterService.generateTimLogs(payload)
          .then((response) => {
            const { data } = response;
          })
          .catch((err) => {
            console.log("ERROR", err);
          });
      }
    },
    generateTimMerchantReceipts(data) {
      if (backendSocket && backendSocket.connected) {
        backendSocket.emit("generate-merchant-receipts", data);
      } else {
        console.log("Socket not connected");
      }
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
      if (this.onLine) {
        document.getElementById("app").style.background = "#3876d2";
      } else {
        document.getElementById("app").style.background = "#fff";
      }
    },
    handleWalkThroughFinished(id) {
      setTourComplete(id);
      this.tours = getTours(true);
    },
    getSetupStatus: function () {
      SetupService.SetupStatus()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.isSetupAllowed) {
            console.log("data.status :", data.status);
            console.log("data.route :", data.route);
            this.$router.replace({
              path: data.route,
            });
          }
        })
        .catch((err) => {
          // this.$router.push({
          //   name: "Error404"
          // });
        });
    },
    ...mapActions(["setIsMobile", "generateTimCardHolderReceipt"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue